<template>
<mdb-container id="galeria" class="mt-5 text-center mb-5">
    <h5 class="mb-5">Galeria</h5>
    <mdb-row class="mb-5">
        <div class="col-6 col-lg-2 col-md-4 col-sm-4">
            <div class="">
                <mdb-btn @click.native="show_img = 'all'" outline="black" class="filter btn-block" dark-waves>Todas</mdb-btn>
            </div>
        </div>
          <div class="col-6 col-lg-2 col-md-4 col-sm-4">
           <div class="">
                <mdb-btn @click.native="show_img = 'ext'" outline="black" class="filter btn-block" dark-waves>Exterior</mdb-btn>
            </div>
        </div>
        <div class="col-6 col-lg-2 col-md-4 col-sm-4">
           <div class="">
                <mdb-btn @click.native="show_img = 'pg'" outline="black" class="filter btn-block" dark-waves>Piscina G.</mdb-btn>
            </div>
        </div>
        <div class="col-6 col-lg-2 col-md-4 col-sm-4">
           <div class="">
                <mdb-btn @click.native="show_img = 'pp'" outline="black" class="filter btn-block" dark-waves>Piscina P.</mdb-btn>
            </div>
        </div>
        <div class="col-6 col-lg-2 col-md-4 col-sm-4">
           <div class="">
                <mdb-btn @click.native="show_img = '8'" outline="black" class="filter btn-block" dark-waves>8 Per.</mdb-btn>
            </div>
        </div>
        <div class="col-6 col-lg-2 col-md-4 col-sm-4">
           <div class="">
                <mdb-btn @click.native="show_img = '10'" outline="black" class="filter btn-block" dark-waves>10 Per.</mdb-btn>
            </div>
        </div>
        <!-- <mdb-col md="3" class=" justify-content-center mb-5">
            <div class="col-4 col-lg-2 col-md-2  col-sm-12">
                <mdb-btn @click.native="show_img = 'all'" outline="black" class="filter" dark-waves>Todas</mdb-btn>
            </div>
              <div class="col-4 col-lg-2 col-md-2 col-3 col-sm-12">
                <mdb-btn @click.native="show_img = 'all'" outline="black" class="filter" dark-waves>Todas</mdb-btn>
            </div>
            <div class="col-lg-2 col-md-6 col-3 col-sm-12">
                <mdb-btn @click.native="show_img = 'ext'" outline="black" class="filter" dark-waves>Exterior</mdb-btn>
            </div>
            <div class="col-lg-2 col-md-6 col-3 ">
                <mdb-btn @click.native="show_img = 'pg'" outline="black" class="filter" dark-waves>Piscina G.</mdb-btn>
            </div>
            <div class="col-lg-2 col-md-6">
                <mdb-btn @click.native="show_img = 'pp'" outline="black" class="filter" dark-waves>Piscina P.</mdb-btn>
            </div>
            <div class="col-lg-2 col-md-6">
                <mdb-btn @click.native="show_img = '8'" outline="black" class="filter" dark-waves>8 Per.</mdb-btn>
            </div>
            <div class="col-lg-2 col-md-6">
                <mdb-btn @click.native="show_img = '10'" outline="black" class="filter" dark-waves>10 Per.</mdb-btn>
            </div>
        </mdb-col> -->
    </mdb-row>
    <div class="gallery" id="gallery">
        <!-- Grid column -->
        <div class="row">
        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'ext'" class="mb-3 pics all 2 animation col-12 col-lg-4" style="">
                <img class="img-fluid " src="../assets/img/ext_1.jpg" alt="Card image cap">
            </div>
        </transition>
        
        <!-- Grid column -->

        <!-- Grid column -->
        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'ext'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/ext_2.jpg" alt="Card image cap">
            </div>
        </transition>
        <!-- Grid column -->

        <!-- Grid column -->
        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'ext'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/ext_3.jpg" alt="Card image cap">
            </div>
        </transition>
        <!-- Grid column -->

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'pg'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/pg_1.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'pg'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/pg_2.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'pg'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/pg_3.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'pp'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/pp_1.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'pp'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/pp_2.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === 'pp'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/pp_3.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === '10'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/10_1.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === '10'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/10_2.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === '10'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/10_3.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === '8'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/8_1.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === '8'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/8_2.jpg" alt="Card image cap">
            </div>
        </transition>

        <transition @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave">
            <div v-if="show_img === 'all' || show_img === '8'" class="mb-3 pics all 1 animation col-12 col-lg-4" style="">
                <img class="img-fluid" src="../assets/img/8_3.jpg" alt="Card image cap">
            </div>
        </transition>

    </div>
    </div>
</mdb-container>
</template>

<script>
import {
    mdbRow,
    // mdbCol,
    mdbBtn,
    mdbContainer,
} from 'mdbvue';
export default {
    data() {
        return {
            show: false,
            show_img: 'pg',
        }
    },
    methods: {
        enter(el) {
            el.style.opacity = 0;
        },
        afterEnter(el) {
            el.style.opacity = 1;
        },
        beforeLeave(el) {
            el.style.opacity = 0;
        }
    },
    components: {
        mdbRow,
        // mdbCol,
        mdbBtn,
        mdbContainer,
    }
}
</script>

<style lang="css">
   
@media (max-width: 575px) {  }


@media (max-width: 767px) {  }


@media (max-width: 991px) {  }


@media (max-width: 1199px) { 
    .btn-block{
        font-size: .7rem !important;
        margin-bottom: 16px !important;
    }
 }    
</style>
